const password = ["mdi-eye", "mdi-eye-off"];
// TODO: const password = { on: "mdi-eye", off: "mdi-eye-off" };

export { password };
